'use client';

import Link from 'next/link';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        {/* 404 Icon */}
        <div className="mb-8">
          <span className="text-9xl font-bold text-gray-200">404</span>
        </div>

        {/* Nachricht */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Seite nicht gefunden
        </h1>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          Die angeforderte Seite existiert nicht oder wurde verschoben.
          Bitte kehren Sie zum Dashboard zuruck oder verwenden Sie die Navigation.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Home className="h-4 w-4" />
            Zum Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Zuruck
          </button>
        </div>
      </div>
    </div>
  );
}
